import "./OfferUnlockedModal.css";

/**
 * ReferralCreditModal
 *
 * Default Mode counterpart to OfferUnlockedModal — shown to a referred
 * customer whose hub has no active campaign, right after they save their
 * first address (same trigger point as the Campaign Mode popup). Reuses
 * OfferUnlockedModal's card/hero styling for visual consistency, but there's
 * no meal-count/cap chips to show and no CTA — per the requirements doc,
 * this is confirmation-only.
 *
 * Props:
 *   isOpen   {boolean}
 *   amount   {number}  — the wallet credit just granted
 *   onClose  {function}
 */
const ReferralCreditModal = ({ isOpen, amount, onClose }) => {
  if (!isOpen || !amount) return null;

  return (
    <div className="oum-overlay" onClick={onClose}>
      <div
        className="oum-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Referral credit received"
      >
        <button className="oum-close-btn" onClick={onClose} aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <div className="oum-hero">
          <div className="oum-hero-blob oum-hero-blob--tl" />
          <div className="oum-hero-blob oum-hero-blob--br" />

          <div className="oum-gift-ring" aria-hidden="true">
            <span className="oum-gift-emoji">🎁</span>
          </div>

          <p className="oum-headline-top">You got</p>
          <p className="oum-headline-main">
            <span className="oum-headline-count">₹{amount}</span>
            <span className="oum-headline-word"> off!</span>
          </p>

          <div className="oum-hero-sub">
            <span className="oum-sub-item">
              Use it on your first order
            </span>
            <span className="oum-sub-dot" aria-hidden="true" />
            <span className="oum-sub-item">This offer ends in 7 days</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralCreditModal;
